import { createSelector } from "reselect";

const getBanners = (state) => state.entities.banners;

export const getAllBanners = createSelector(getBanners, (banners) =>
  Object.values(banners)
);
